module.exports = __webpack_public_path__ + "img/logo.da7cea14.png";